(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["signoptima-product-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('signoptima-gallery')) {
  customElements.define('signoptima-gallery', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const options = {signal:this.controller.signal};
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-target]');
        if (button && this.contains(button)) this.showImage(button.dataset.target);
      }, options);
      const section = this.closest('[data-section-type="product-template"]');
      this.lastVariant = this.dataset.initialVariant;
      if (this.dataset.selectedImage) this.showImage(this.dataset.selectedImage);
      this.updateVariant = () => {
        const source = section?.querySelector('[id^="ProductJson-"]');
        if (!source) return;
        const product = JSON.parse(source.textContent);
        const variant = product.variants.find(item => String(item.id) === this.lastVariant);
        if (!variant) return;
        const studio = this.querySelector('[data-kind="studio"]');
        const values = variant.options || [variant.option1, variant.option2, variant.option3];
        const colorMatches = !this.dataset.studioColor || values.some(value => String(value).toLowerCase() === this.dataset.studioColor.toLowerCase());
        const variantMatches = !this.dataset.studioVariant || String(variant.id) === this.dataset.studioVariant;
        if (studio && colorMatches && variantMatches) this.showImage(studio.dataset.slide);
        else if (variant.featured_image) this.showImage(String(variant.featured_image.id), true);
        else {
          const original = this.querySelector('[data-kind="original"]');
          if (original) this.showImage(original.dataset.slide, true);
        }
      };
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', this.updateVariant, {...options, once:true});
      else this.updateVariant();
      if (section) section.addEventListener('change', event => {
        if (!event.target.matches('select, input[type="radio"]')) return;
        window.setTimeout(() => {
          const selector = section.querySelector('select.product-variants');
          if (!selector || selector.value === this.lastVariant) return;
          this.lastVariant = selector.value;
          this.updateVariant();
        }, 0);
      }, options);
    }
    disconnectedCallback() { this.controller?.abort(); }
    showImage(id, revealThumb = false) {
      const slides = [...this.querySelectorAll('[data-slide]')];
      if (!slides.some(slide => slide.dataset.slide === String(id))) return;
      slides.forEach(slide => { slide.hidden = slide.dataset.slide !== String(id); });
      this.querySelectorAll('[data-target]').forEach(button => {
        const selected = button.dataset.target === String(id);
        button.setAttribute('aria-pressed', String(selected));
        if (selected && revealThumb) {
          const rail = button.parentElement;
          rail.scrollTo({left:button.offsetLeft - rail.offsetLeft, behavior:'smooth'});
        }
      });
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
